export enum CheckConfigTypes {
  DIRTY = "dirty",
  CLEAN = "clean",
  INPECTED = "inpected",
}
